var ranScripts={};
// 従来版のSVG読み込み状況
var ary_svg_loading_condition=[];
// リファクタリング版のSVG読み込み状況
var ary_svg_loading_condition2=[];
var ary_svg_full_loading_condition=[];

window.hoge = ary_svg_loading_condition2;
window.hoge2 = ary_svg_full_loading_condition;

class ExternSVG extends HTMLElement {
  constructor() {
    super();
    let slideUrl = this.getAttribute('src');
  }

  
  connectedCallback() {
    let imgUrl = this.getAttribute('src');
    fetch(imgUrl)
      .then(response => response.text())
      .then(text => {
        let filtered_text;

        filtered_text = text.replace(`<!--?xml version="1.0" encoding="UTF&#45;8"?-->`,"");
        
        this.insertAdjacentHTML('afterbegin',filtered_text);

        ary_svg_loading_condition2.push(imgUrl);

        /***********************************************************/
        var svg = this.querySelector(':scope svg');
        var scripts = this.querySelectorAll(':scope script');
        var scriptsToEval = [];
        var script, scriptType;

        for (var k = 0, scriptsLen = scripts.length; k < scriptsLen; k++) {
            scriptType = scripts[k].getAttribute('type');

            // Only process javascript types.
            // SVG defaults to 'application/ecmascript' for unset types
            if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript') {

            // innerText for IE, textContent for other browsers
            script = scripts[k].innerText || scripts[k].textContent;

            // Stash
            scriptsToEval.push(script);

            // Tidy up and remove the script element since we don't need it anymore
            svg.removeChild(scripts[k]);
            }

        }
        /***********************************************************/

        if (scriptsToEval.length > 0 && !ranScripts[imgUrl]) {
            for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {

            // scriptタグのコードはクロージャの中で動くので、グローバルスコープの変数や関数が使えない。
            // これらを使う場合は、windowオブジェクトにあらかじめ必要なものをぶら下げておく必要がある。
            new Function(scriptsToEval[l])(window); // jshint ignore:line
            }                
        }
        ranScripts[imgUrl] = true;

        /***********************************************************/
        //TODO: 全てのimage要素のロードが完了した時のイベントを発生させる。
        
        // 配列要素は次のフィールドを持つ連想配列とする。
        // DOM_image:image要素(DOMオブジェクト)
        // loaded:bool(読み込み完了でtrue)
        
        let ary_image_loading_condition={};

        var ary_DOM_image = this.querySelectorAll(':scope image');

        for(let DOM_image of ary_DOM_image){
            let image_id_base=`${DOM_image.id}`
            let index=0;
            let image_id;

            // すでに同名のimage_idがある時は名前を微妙に変える
            do{
                if(index === 0){
                    image_id=`${image_id_base}`;
                }
                // すでにimage_idが使われている場合
                if(image_id in ary_image_loading_condition){
                    // 次の番号を採番して再度やり直す。
                    index++;
                    image_id=`${image_id_base}_dup_${index+1}`;
                    continue;
                }
                ary_image_loading_condition[image_id]=false;
                DOM_image.addEventListener('load',()=>{
                    ary_image_loading_condition[image_id]=true;

                    if(Object.values(ary_image_loading_condition).every((e)=>e)){
                        let all_external_image_load_event;
                        all_external_image_load_event = new CustomEvent("allexternalimageloaded",{
                            target:svg
                        });
                        //console.log(`all image load:${svg.id}`);


                        ary_svg_full_loading_condition.push(imgUrl);

                        if(svg){

                            svg.dispatchEvent(all_external_image_load_event);
                        }
                        if(svg.parentNode){
                            svg.parentNode.dispatchEvent(all_external_image_load_event);
                        }
        
                    };
                });
            // image_idが新規キーの場合に脱出する
            } while((image_id in ary_image_loading_condition) === false);
        }

        // TBD

      });
  }

}

module.exports.define_svg_element = () => {
    customElements.define('extern-svg', ExternSVG);
}

const if_loaded_all=(ary_svg_loading_condition)=>{
    return ary_svg_loading_condition.every((e)=> e.loaded);

}

/**
 * 
 * @param {*} ary_selector_extern_svg 対象にするextern_svg要素のセレクタの配列
 * @summary 
 * 対象にしたextern_svg要素の全てが読み込まれた時、all_svg_readyイベントを発火する
 * 対象のextern_svg要素はcssセレクタで指定、これを配列で束ねて、引数で使用する
 * ● なお、cssセレクタが無効な場合、無視して他の対象を監視する。
 * ● なお、cssセレクタで複数の要素をセレクトしてしまう場合は、初めに見つかった要素のみが対象になる。
 * 現在、当該ルーチンを複数回呼び出した場合、正常動作は想定していない。
 * 
 */
module.exports.emit_on_all_svg_loaded = (ary_selector_extern_svg) => {

    // ary_svg_loading_conditionの生成
    ary_svg_loading_condition = [];
    for(const selector_extern_svg of ary_selector_extern_svg){
        ary_svg_loading_condition.push(
            {
                selector_extern_svg:selector_extern_svg,
                loaded:false
            }
        );
    }

    for(const target of ary_svg_loading_condition){
        let DOM_target = document.querySelector(target.selector_extern_svg);
        // cssセレクタが無効
        if(DOM_target === null) continue;

        DOM_target.addEventListener('svgready',
                (e)=>{
                    let event;
                    target.loaded = true;
                    if(if_loaded_all(ary_svg_loading_condition)){

                        event = new CustomEvent("all_svg_ready",{detail:{
                            ary_svg_loading_condition
                        }});
                        //console.log(ary_svg_loading_condition);
                        window.dispatchEvent(event);
                        
                    }
                }
        );

    }

}

/**
 * 
 * @param { * } ary_selector_extern_svg extern-svg要素のIDを格納した配列
 * 
 * @note 
 *
 * extern-svg要素で読み込むsvgにimage要素がない場合は永久に監視を続けたまま処理が進まない。
 * そのようなsvgを監視させないこと。
 *
 * 外部参照画像が見つからない場合も永久に監視が続くので注意
 */
module.exports.emit_on_all_svg_full_loaded = (ary_selector_extern_svg) => {

    // ary_svg_loading_conditionの生成
    ary_svg_loading_condition = [];
    for(const selector_extern_svg of ary_selector_extern_svg){
        ary_svg_loading_condition.push(
            {
                selector_extern_svg:selector_extern_svg,
                loaded:false
            }
        );
    }

    for(const target of ary_svg_loading_condition){
        let DOM_target = document.querySelector(target.selector_extern_svg);
        // cssセレクタが無効
        if(DOM_target === null) continue;

        DOM_target.addEventListener('allexternalimageloaded',
                (e)=>{
                    let event;
                    target.loaded = true;
                    if(if_loaded_all(ary_svg_loading_condition)){

                        event = new CustomEvent("all_svg_ready",{detail:{
                            ary_svg_loading_condition
                        }});
                        //console.log(ary_svg_loading_condition);
                        window.dispatchEvent(event);
                        
                    }
                }
        );

    }

}


module.exports.emit_on_all_svg_loaded2 = (ary_assumed_load_condision,event_name="all_svg_ready") => {

    const check_all_loading_finished = ()=>{
      let load_all;
  
      load_all = ary_assumed_load_condision.every((e)=>ary_svg_loading_condition2.includes(e));
      if(load_all){
          evt = new CustomEvent(event_name,{detail:{
            ary_svg_loading_condition2
          }});
          window.dispatchEvent(evt);
      } else {
        setTimeout(check_all_loading_finished,100);
      }
    }
  
    setTimeout(check_all_loading_finished,100);
}

module.exports.emit_on_all_svg_full_loaded2 = (ary_assumed_load_condision,event_name="all_svg_ready") => {

    const check_all_loading_finished = ()=>{
      let load_all;
    
      load_all = ary_assumed_load_condision.every((e)=>ary_svg_full_loading_condition.includes(e));
      if(load_all){
          evt = new CustomEvent(event_name,{detail:{
            ary_svg_full_loading_condition
          }});
          window.dispatchEvent(evt);
      } else {
        setTimeout(check_all_loading_finished,100);
      }
    }
  
    setTimeout(check_all_loading_finished,100);
}
